export { default } from './Tile';
